module.exports = __webpack_public_path__ + "img/offenen-positionen-v2.fa9369c7.jpg";